import AppThemeIcon from "@core-components/icon/AppThemeIcon";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Button, Checkbox, Image, Indicator, Menu } from "@mantine/core";
import CRank from "@modules/order/models/CRank";
import { IconChevronDown } from "@tabler/icons-react";
import type { ReactNode } from "react";
import Icon from "../../shared/icon/Icon";

interface IOption {
  value: string;
  label: ReactNode;
  rankKey: string;
}

const options: IOption[] = [
  {
    value: "iron",
    label: (
      <span>
        <Image
          className="inline-block"
          h={20}
          src={CRank.variants[CRank.IRON].icon}
          w={20}
        />{" "}
      </span>
    ),
    rankKey: "iron",
  },
  {
    value: "bronze",
    label: (
      <div>
        <Image
          className="inline-block"
          h={20}
          src={CRank.variants[CRank.BRONZE].icon}
          w={20}
        />{" "}
      </div>
    ),
    rankKey: "bronze",
  },
  {
    value: "silver",
    label: (
      <div>
        <Image
          className="inline-block"
          h={20}
          src={CRank.variants[CRank.SILVER].icon}
          w={20}
        />{" "}
      </div>
    ),
    rankKey: "silver",
  },
  {
    value: "gold",
    label: (
      <div>
        <Image
          className="inline-block"
          h={20}
          src={CRank.variants[CRank.GOLD].icon}
          w={20}
        />{" "}
      </div>
    ),
    rankKey: "gold",
  },
  {
    value: "platinum",
    label: (
      <div>
        <Image
          className="inline-block"
          h={20}
          src={CRank.variants[CRank.PLATINUM].icon}
          w={20}
        />{" "}
      </div>
    ),
    rankKey: "platinum",
  },
  {
    value: "emerald",
    label: (
      <div>
        <Image
          className="inline-block"
          h={20}
          src={CRank.variants[CRank.EMERALD].icon}
          w={20}
        />{" "}
      </div>
    ),
    rankKey: "emerald",
  },
  {
    value: "diamond",
    label: (
      <div>
        <Image
          className="inline-block"
          h={20}
          src={CRank.variants[CRank.DIAMOND].icon}
          w={20}
        />{" "}
      </div>
    ),
    rankKey: "diamond",
  },
];

interface IRankSelect {
  values: string[];
  onChange: (values: string[]) => void;
}

const RankSelect: React.FC<IRankSelect> = ({ values, onChange }) => {
  const { t } = useAppTranslation("components.rankedFilters");

  return (
    <Menu>
      <Menu.Target>
        <Indicator
          processing
          classNames={{
            indicator: "before:bg-secret-blue-light bg-secret-blue-light z-10",
          }}
          disabled={values.length === 0}
        >
          <Button
            classNames={{
              root: "default-icon border-primary-lighter",
              section: "contents",
            }}
            leftSection={
              <AppThemeIcon className="size-7">
                <Icon.Rank className="pr-2" />
              </AppThemeIcon>
            }
            radius={8}
            rightSection={<IconChevronDown />}
          >
            {t("rank.label")}
          </Button>
        </Indicator>
      </Menu.Target>

      <Menu.Dropdown
        classNames={{
          dropdown: "bg-primary-default border-secret-blue-light p-3 !w-40",
        }}
      >
        <Checkbox.Group value={values} onChange={onChange}>
          {options.map((option) => {
            return (
              <Checkbox
                key={option.value}
                labelPosition="left"
                classNames={{
                  root: "cursor-pointer hover:bg-primary-background py-1 rounded-md",
                  label: "cursor-pointer p-1 flex gap-2",
                  labelWrapper: "w-full",
                  body: "py-1 text-white",
                  input: "!bg-transparent border-none",
                  inner: "my-auto",
                }}
                iconColor="white"
                label={
                  <>
                    {option.label} {t(`rank.${option.rankKey}`)}
                  </>
                }
                value={option.value}
              />
            );
          })}
        </Checkbox.Group>
      </Menu.Dropdown>
    </Menu>
  );
};

export default RankSelect;
